export default "__VITE_ASSET__d2afef0d__"